import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/standard';
import { SnackbarService } from '../../services/standard/snackbar.service';

@Component({
  selector: 'prism-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  showLoader$ = this.authService.showLoginLoader.asObservable();
  minPassChars = 6;

  loginForm: UntypedFormGroup = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(this.minPassChars)]]
  });

  constructor(private formBuilder: UntypedFormBuilder,
              private router: Router,
              private authService: AuthenticationService,
              private snackbarService: SnackbarService
  ) {
  }

  ngOnInit() {
  }

  public onLogin(validState) {
    if (validState) {
      const email = this.loginForm.controls['email'].value;
      const password = this.loginForm.controls['password'].value;

      if (this.loginForm.valid) {
        this.loginForm.disable();
        this.authService.login(email, password)
          .then(success => null)
          .catch(error => {
            this.loginForm.enable();
            this.snackbarService.handleError(error);
          });
      }
    }
  }
}
